"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/es.regexp.constructor.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.regexp.to-string.js");

function setKey(key) {
  return "zz_utils_".concat(location.hostname, "_").concat(key).toLocaleUpperCase();
}

var myLocalStorage = {};
/**
 * @function LocalStorage[get] - 获取localStorage存储的数据，代替getItem
 * @param {string} key 存储的key，为空则返回所有使用该工具存储的localstorage的值
 * @example
 * import { LocalStorage } from '@zz-biz/utils';
 * 
 * LocalStorage.get('system_config');
 * // { test: 1 }
 * 
 * // 返回所有，ZZ_UTILS_CRM.ZHUANSPIRIT.COM是按照站点规则自动生成
 * LocalStorage.get();
 * // { 'ZZ_UTILS_CRM.ZHUANSPIRIT.COM_SYSTEM_CONFIG': { test: 1 } }
 * 
 * @returns {any} 存储的值
 */

myLocalStorage.get = function () {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  try {
    var getValue = function getValue(val) {
      if (!val) return undefined;
      var obj = JSON.parse(val); //如果当前时间-减去存储的元素在创建时候设置的时间 > 过期时间

      if (obj.expire && +new Date() - obj.time > obj.expire) {
        return undefined;
      }

      return obj.value;
    };

    if (key) {
      var value = localStorage.getItem(setKey(key));
      return getValue(value);
    } else {
      var result = {};
      var regexp = new RegExp("^zz_utils_".concat(location.hostname), 'i');

      for (var i in localStorage) {
        if (localStorage[i] && regexp.test(i) && getValue(localStorage[i])) {
          result[i] = getValue(localStorage[i]);
        }
      }

      return result;
    }
  } catch (err) {
    console.warn(err);
  }
};
/**
 * @function LocalStorage[set] - 设置localStorage，代替setItem
 * @param {string} key 存储的key
 * @param {any} value 存储的值
 * @param {number} [expire=0] 过期时间，默认永久，单位毫秒
 * @example
 * import { LocalStorage } from '@zz-biz/utils';
 * 
 * // 普通永久保存
 * LocalStorage.set('test', { test: 1 });
 * // 保存一天
 * LocalStorage.set('test', { test: 1 }, 24 * 60 * 60 * 1000);
 */


myLocalStorage.set = function () {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var expire = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  try {
    if (key) {
      //转换成json字符串序列
      localStorage.setItem(setKey(key), JSON.stringify({
        value: value,
        time: +new Date(),
        expire: expire
      }));
    }
  } catch (err) {
    console.warn(err);
  }
};
/**
 * @function LocalStorage[remove] - 删除localStorage存储的值，代替removeItem
 * @param {string} key 存储的key
 * @example
 * import { LocalStorage } from '@zz-biz/utils';
 * 
 * // 删除存储的值
 * LocalStorage.remove('test');
 */


myLocalStorage.remove = function () {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (key) {
    localStorage.removeItem(setKey(key));
  }
};

var _default = myLocalStorage;
exports["default"] = _default;